import cx from "classnames";
import React, { PropsWithChildren } from "react";

type SpanClassName = React.DetailedHTMLProps<
  React.HTMLAttributes<HTMLSpanElement>,
  HTMLSpanElement
>["className"];

type DivClassName = React.DetailedHTMLProps<
  React.HTMLAttributes<HTMLDivElement>,
  HTMLDivElement
>["className"];

type LabeledValueExtraProps = {
  label: string;
  value: string;
  labelClassName?: SpanClassName;
  valueClassName?: SpanClassName;
  valueChildrenClassName?: DivClassName;
};

export type LabeledValueProps = Omit<
  React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement>,
  "children"
> &
  LabeledValueExtraProps;

export const LabeledValue = ({
  className,
  label,
  value,
  labelClassName,
  valueClassName,
  valueChildrenClassName,
  children,
  ...props
}: PropsWithChildren<LabeledValueProps>) => (
  <span className={cx("flex justify-between", className)} {...props}>
    <span className={labelClassName}>{label}</span>
    <div className={cx("flex space-x-2 lg:flex-col", valueChildrenClassName)}>
      <span className={cx("font-bold", valueClassName)}>{value}</span>
      {children}
    </div>
  </span>
);
